<div mat-dialog-title>
	{{ title }}
</div>

<mat-dialog-content style="min-height: 300px;" [formGroup]="form">
	<user-picker
		formControlName="user"
		[selectSingle]="true"
		[showUserIds]="true"
		[filterIds]="excludeIds"
		[searchLocalOnly]="true"
		[updateUserTableFromDirectory]="false"
		[enableNonANRCollaborator]="false"></user-picker>

	<p class="text-muted small mt-3">
		<i class="fa fa-fw fa-info-circle"></i>
		Search by name, email address, or employee ID.
	</p>
</mat-dialog-content>

<mat-dialog-actions>
	<button (click)="cancel()" class="btn btn-link">
		Cancel
	</button>
	<button (click)="save()" class="btn btn-primary" [disabled]="!selectedUserId">
		Select
	</button>
</mat-dialog-actions>
